const UserProject = 'UserProject';

export const ACCEPT_GDPR_REQUEST = `${UserProject}/ACCEPT_GDPR_REQUEST`;

export const CHANGE_USER_PROJECT_REQUEST = `${UserProject}/CHANGE_USER_PROJECT_REQUEST`;
export const CHANGE_USER_PROJECT_AND_JOURNEY_REQUEST = `${UserProject}/CHANGE_USER_PROJECT_AND_JOURNEY_REQUEST`;
export const SAVE_AND_SWITCH_REQUEST = `${UserProject}/SAVE_AND_SWITCH_REQUEST`;

export const FETCH_USER_CONTEXT_REQUEST = `${UserProject}/FETCH_USER_CONTEXT_REQUEST`;
export const FETCH_USER_CONTEXT_RESPONSE = `${UserProject}/FETCH_USER_CONTEXT_RESPONSE`;
export const FETCH_USER_CONTEXT_ERROR = `${UserProject}/FETCH_USER_CONTEXT_ERROR`;

export const UPDATE_USER_PROFILE_REQUEST = `${UserProject}/UPDATE_USER_PROFILE_REQUEST`;
export const UPDATE_USER_PROFILE_RESPONSE = `${UserProject}/UPDATE_USER_PROFILE_RESPONSE`;

export const VIEW_AS_USER_REQUEST = `${UserProject}/VIEW_AS_USER_REQUEST`;
export const VIEW_AS_USER_RESPONSE = `${UserProject}/VIEW_AS_USER_RESPONSE`;
export const VIEW_AS_USER_ERROR = `${UserProject}/VIEW_AS_USER_ERROR`;
